<template>
  <footer id="site-footer">
    <div class="bootstrap-wrapper">
      <div class="container-fluid">
        <div class="row contentFooter">
          <div class="d-flex justify-content-between w-100 footerMenu1 row">
            <div class="col-lg-2 col-12 d-flex flex-column justify-content-lg-between justify-content-start mb-3 mb-lg-0">
              <div class="imagenes">
                <img class="d-block mb-3" src="../../assets/img/posadas.svg" alt="Posadas Corporate">
              </div>

              <ul class="list-group list-group-footer d-flex flex-lg-column flex-row">
                <li class=" d-lg-block d-inline"> 
                  <p class="notas mb-3 pr-3 ">
                    <a class="cta-footer" v-on:click="redirecPoliticas" onclick="return false;" href="#">{{$t('language.posadasCorporate.footer.politicasUso')}}</a>
                  </p>
                </li>
                <li class=" d-lg-block d-inline"> 
                  <p class="notas mb-3">
                    <a class="cta-footer" v-on:click="redirecTerminos" onclick="return false;" href="#">{{$t('language.posadasCorporate.footer.terminosCondiciones')}}</a>
                  </p>
                </li>
              </ul>
            </div>
            <div class="col-lg-10 col-12">
              <p class="mb-4"><b>{{$t('language.posadasCorporate.footer.ayudaCorporate')}}</b></p>
              <div class="row">

                <div class="col-lg-4">
                  <ul class="list-group list-group-footer">
                    <li class=""> 
                      <p class="mb-3">
                        <b>{{$t('language.posadasCorporate.footer.telefono')}}</b>
                      </p>
                    </li>
                    <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-telephone"> </i> 
                        {{$t('language.posadasCorporate.footer.mexico')}}: <a class="cta-footer" href="tel:4432982253">44 3298 2253</a>
                      </p>
                    </li>
                    <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-telephone"> </i> 
                        {{$t('language.posadasCorporate.footer.usa')}}: <a class="cta-footer" href="tel:18552636094">1 855 26 36 094</a>
                      </p>
                    </li>
                  </ul>
                </div>

                <div class="col-lg-4">
                  <ul class="list-group list-group-footer">
                    <li class=""> 
                      <p class="mb-3">
                        <b>{{$t('language.posadasCorporate.footer.mensajeriaInstantanea')}}</b>
                      </p>
                    </li>
                    <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-whatsapp"> </i> 
                        <a class="cta-footer" v-on:click="perfection1000" onclick="return false;" href="#">44 3137 8728</a>
                      </p>
                    </li>
                    <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-chat"> </i> 
                        <a class="cta-footer" v-on:click="perfection3" onclick="return false;" href="#">{{$t('language.posadasCorporate.footer.chat')}}</a>
                      </p>
                    </li>
                  </ul>
                </div>

                <div class="col-lg-4">
                  <ul class="list-group list-group-footer">
                    <li class=""> 
                      <p class="mb-3">
                        <b>{{$t('language.posadasCorporate.footer.email')}}</b>
                      </p>
                    </li>
                    <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-mail"> </i> 
                        <a class="cta-footer" href="mailto:soportecorporate@posadas.com">soportecorporate@posadas.com</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div> 
            </div>
          </div>


          <div class="d-flex justify-content-between w-100 footerMenu2 mt-5 row">
            <div class="col-lg-2 col-8 mb-4 mb-lg-0">
                <p class="notas">Copyright<sup>©</sup> 2019 Posadas Corporate</p>
            </div>
            <div class="col-lg-2 col-6 d-flex justify-content-between align-items-center row txt-left customFooter-padding-right">
              <a class="d-inline-block col-lg-6 col-4 mb-4 mb-lg-0 text-center" v-on:click="perfection24">
                <img class="logoFooter" src="../../assets/img/footer/live-aqua.svg" alt="Posadas Corporate">
              </a>
              <a class="col-lg-6 col-4 mb-4 mb-lg-0 text-center" v-on:click="perfection25">
                <img class="logoFooter" src="../../assets/img/footer/grand-fiesta.svg" alt="Posadas Corporate">
              </a>
            </div>	
            <div class="col-lg-8 col-14 d-flex justify-content-between align-items-center row" style="margin-right:0px; margin-right:0px">
              <a class="d-inline-block col-lg-1 col-4 mb-4 mb-lg-0 text-center" v-on:click="perfection32">
                <img class="logoFooter" src="https://cms.posadas.com/documents/3110971/3153216/IOH_R_logoH_entre2-3cm.jpg/80eae83f-cd89-1158-247e-16dfab01ee4a?t=1663250064867" alt="Posadas Corporate">
              </a>
              <a class="d-inline-block col-lg-2 col-4 mb-4 mb-lg-0 text-center" v-on:click="perfection31">
                <img class="logoFoote" src="../../assets/img/footer/image.png" alt="Posadas Corporate">
              </a>
              

              <a class="d-inline-block col-lg-2 col-4 mb-4 mb-lg-0 text-center" v-on:click="perfection26">
                <img class="logoFooter" src="../../assets/img/footer/fiesta-americana.svg" alt="Posadas Corporate">
              </a>
              <a class="d-inline-block col-lg-2 col-4 mb-4 mb-lg-0 text-center" v-on:click="perfection27">
                <img class="logoFooter" src="../../assets/img/footer/fiesta-inn.svg" alt="Posadas Corporate">
              </a>
              <a class="d-inline-block col-lg-2 col-4 mb-4 mb-lg-0 text-center" v-on:click="perfection28">
                <img class="logoFooter2" src="../../assets/img/footer/gamma.svg" alt="Posadas Corporate">
              </a>
              <a class="d-inline-block col-lg-1 col-4 mb-4 mb-lg-0" v-on:click="perfection29">
                <img class="logoFooter2" src="../../assets/img/footer/one.svg" alt="Posadas Corporate">
              </a>
              <a class="d-inline-block col-lg-2 col-4 mb-4 mb-lg-0 text-center" v-on:click="perfection30">
                <img class="logoFooter" src="../../assets/img/footer/Explorean.png" alt="Posadas Corporate">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import SecureLS from 'secure-ls';

export default {

  
  name: 'Footer',
  props: {},
  data() {
    return {
      language: '',
      ls: new SecureLS({ encodingType: "aes" }),
    }
  },
  methods: {
    redirecTerminos(){
      if (this.ls.get('Token')) {
        window.open('/terminos-condiciones', '_blank');
      } else {
        this.$router.push({ name: 'TerminosCondiciones'});
      }
    },
    redirecPoliticas() {
      (this.ls.get('Language').data=='es'?window.open(process.env.VUE_APP_POLICIES, '_blank'):window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
    },
    perfection1000() {
            window.open(process.env.VUE_APP_WHATSAPP, '_blank');

    },
    perfection32() {
                      var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {
            window.open("https://www.ioh-hoteles.com/", '_blank');

          } else {
            window.open("https://www.ioh-hoteles.com/en", '_blank');
          }
          },
    perfection31() {
      window.open(process.env.VUE_APP_CURAMORIA, '_blank');
    },
     perfection30() {
                      var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {
            window.open(process.env.VUE_APP_EXPLOREAN, '_blank');

          } else {
            window.open(process.env.VUE_APP_EXPLOREANEN, '_blank');

          }
    },
     perfection29() {
               var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {
            
            window.open(process.env.VUE_APP_ONE, '_blank');
          } else {
            window.open(process.env.VUE_APP_ONEEN, '_blank');

          }
    },
    perfection28() {
              var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {
            
            window.open(process.env.VUE_APP_GAMMA, '_blank');
          } else {
            window.open(process.env.VUE_APP_GAMMAEN, '_blank');

          } 
    },
    perfection27() {
                   var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {
            window.open(process.env.VUE_APP_FIESTAIN, '_blank');
            
          } else {
            window.open(process.env.VUE_APP_FIESTAINEN, '_blank');

          } 
    },
    perfection26() {
                      var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {
            window.open(process.env.VUE_APP_FIESTA, '_blank');
            
          } else {
            window.open(process.env.VUE_APP_FIESTAEN, '_blank');

          } 
    },
    perfection25() {
             var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {
            
            window.open(process.env.VUE_APP_FIESTAMERICANA, '_blank');
          } else {
            window.open(process.env.VUE_APP_FIESTAMERICANAEN, '_blank');

          } 
    },
    perfection24() {
                     var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {
            window.open(process.env.VUE_APP_AQUA, '_blank');
            
          } else {
            window.open(process.env.VUE_APP_AQUAEN, '_blank');

          } 
    },
         perfection2() {
            var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
          if(this.language.data == 'es') {

            window.open(process.env.VUE_APP_CONDITIONS, '_blank');
          } else {
            window.open(process.env.VUE_APP_CONDITIONSEN, '_blank');

          }
        },
         perfection3() {
            var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
              if( this.language.data == 'es' && this.language.data != '' ) {
                window.open(process.env.VUE_APP_CHATES, '_blank');
              } else {
                window.open(process.env.VUE_APP_CHATEN, '_blank');
              }
        }
            
      
        
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // Temporal en lo que tenemos logo
  @import '../../assets/scss/config.scss';
  footer {
    background-color: #f4f4f4 ; 
    width: 100%;
    min-height: 10vh;
    position: relative;
    bottom: 0;
    z-index: 9;
  }

  .customFooter-padding-right {
    @media (min-width: 873px) {
      padding-right: 0 !important;
    }
  }

  .txt-right{
    text-align: right;
    @media (max-width: 873px) {
      text-align: left !important;
    }
  }

  .cta-footer {
    font-size: $font-size-small;
  }

  .contentFooter {
    padding: 48px 42px
  }

  .list-group-footer {
    list-style: none;

    .demo-icon {
      color: $colorBase2;
      font-size: $font-size-large;
    }
  }

  .footerMenu1 {
    border-bottom: 1px solid $colorBase5;
  }

  .logoFooter {
    height: 27px;
  }

  .logoFooter2 {
    height: 20px;
  }

  @media only screen and (max-width: 992px) {
    .logoFooter, .logoFooter2 {
      height: 40px;
    }
  }

</style>
